var _rect, _path, _circle, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAvatarCall = function SvgAvatarCall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_1120_4232)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5923 19.0272C30.6801 18.0423 29.406 17.5 27.9998 17.5C26.586 17.5 25.3077 18.0391 24.3998 19.0178C23.482 20.0073 23.0348 21.3522 23.1398 22.8044C23.3479 25.6694 25.5281 28 27.9998 28C30.4715 28 32.6479 25.6698 32.8593 22.8053C32.9657 21.3662 32.5157 20.0242 31.5923 19.0272ZM36.2498 38.5H19.7498C19.5338 38.5028 19.3199 38.4574 19.1237 38.3672C18.9275 38.2769 18.7538 38.1441 18.6154 37.9783C18.3107 37.6141 18.1879 37.1167 18.2788 36.6137C18.6745 34.4191 19.9092 32.5755 21.8498 31.2812C23.5738 30.1323 25.7577 29.5 27.9998 29.5C30.2418 29.5 32.4257 30.1328 34.1498 31.2812C36.0904 32.575 37.3251 34.4186 37.7207 36.6133C37.8117 37.1162 37.6888 37.6136 37.3842 37.9778C37.2458 38.1437 37.0722 38.2766 36.8759 38.367C36.6797 38.4573 36.4658 38.5028 36.2498 38.5Z",
    fill: "#E2F2FF",
    stroke: "#666666",
    strokeWidth: 0.0625
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.4
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 23.25,
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1120_4232",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50A5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3776AB"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAvatarCall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avatar-call.6af28ae1.svg";
export { ForwardRef as ReactComponent };